<template>
    <div class="password-input-wrapper">
        <label class="base-input text-input" :class="inputClass">
            <span v-if="showLabel" v-text="label"></span>
            <input :type="inputType" v-model="value" :class="inputClass" @input="actionInput" :name="name" :autocomplete="autocomplete"/>

            <span v-if="!correctPassword" class="base-input-desc">Password must contain at least 8 characters, a single uppercase letter, a single lowercase letter, and one number.</span>
            <span v-else-if="!samePasswords" class="base-input-desc">Passwords are not the same.</span>
        </label>

        <span class="toggle-password-icon" @click="togglePasswordVisibility">
            <i :class="['md-icon', 'md-icon-font', 'md-theme-default', 'password-icon']">
                {{ passwordVisible ? 'visibility_off' : 'visibility' }}
            </i>
        </span>
        
        <div v-if="showError" class="base-input-error" v-text="errorMessage"></div>
    </div>
</template>

<script>
    import BaseInput from "./BaseInput.js";

    export default {
        name: "PasswordInput",
        mixins: [BaseInput],
        data() {
            return {
                passwordVisible: false,
            };
        },
        props: {
            checkPassword: {
                type: Boolean,
                default: false,
            },
            samePasswords: {
                type: Boolean,
                default: true,
            },
            name: {
                type: String,
                default: null,
            },
            autocomplete: {
                type: String,
                default: null,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            errorMessage: {
                type: String,
                default: '',
            }
        },
        computed: {
            inputClass() {
                return {
                    'success': this.checkPassword && (this.correctPassword && this.samePasswords) && this.value.length > 0,
                    'error': this.hasError || (this.checkPassword && (!this.correctPassword || !this.samePasswords) && this.value.length > 0),
                }
            },
            showError() {
                return this.hasError && this.errorMessage.length > 0;
            },
            correctPassword() {
                return !this.checkPassword || this.value.length >= 8 && this.value.search(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/) == 0 || this.value.length <= 0;
            },
            inputType() {
                return this.passwordVisible ? 'text' : 'password';
            },
        },
        methods: {
            actionInput() {
                this.$emit('input');
            },
            togglePasswordVisibility() {
                this.passwordVisible = !this.passwordVisible;
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/base-input";

    .password-input-wrapper {
        position: relative;

        .toggle-password-icon {
            position: absolute;
            right: 10px;
            top: 40px;
            transform: translateY(-50%);
            cursor: pointer;

            .password-icon {
                color: #ffffff;
            }
        }

        .base-input-error {
            color: #F93232;
            padding-top: 10px;
            max-width: 245px;
        }
    }
</style>